export enum LoggingTypes {
  delta='DELTA',
  average='AVG',
  minimum='MIN',
  maximum='MAX'
}
